import Tabs from "./Tabs";
import { useState } from "react";
import TabsMobile from "./TabsMobile/TabsMobile";
import { CSSTransition } from "react-transition-group";

export default function FeatureCard() {
  const [activeTab, setActiveTab] = useState(0);

  const tailwindAnimation = {
    appear: "opacity-0",
    appearActive:
      "transition-opacity animate-fade-in-down duration-700 opacity-100",
    enter: "opacity-0 animate-fade-in-down",
    enterActive:
      "transition-opacity duration-700 animate-fade-in-down opacity-100",
    exitActive: "transition-opacity duration-200 opacity-0",
  };

  return (
    <div className="mx-auto container pb-0 md:pb-16 flex justify-center">
      <TabsMobile />
      <div className="w-full pt-64 hidden pt-[90px] pb-28 px-32 md:block bg-doctio-lightgreen p-6 border border-green-600 rounded-2xl">
        <div className="feature-list">
          <div className="flex xl:h-[480px] justify-between">
            <div className="w-2/4 pr-16">
              <div
                className={`hidden ${activeTab === 0 ? "md:block" : "hidden"}`}
              >
                <CSSTransition
                  key={0}
                  timeout={500}
                  unmountOnExit
                  in={activeTab === 0}
                  classNames={tailwindAnimation}
                >
                  <>
                    <h2 className="text-[2.5rem] mb-6 font-bold text-doctio-green">
                      Stort bibliotek af tekstfraser, klikfraser og
                      journalkoncepter
                    </h2>
                    <p className="mt-2 text-left text-[17px] font-medium">
                      Måden at journalføre på er en faglig præference og skøn,
                      og derfor har vi gjort det muligt at tilpasse fraserne
                      efter dit behov. Du har hos Doctio mulighed for at tilgå
                      Doctios standardfraser, oprette dine egne fraser eller
                      redigere eksisterende fraser, så de passer nøjagtig til
                      dig.
                    </p>

                    <p className="mt-8 text-left mb-8 font-medium">
                      Med Doctio Pro har du desuden mulighed for at administrere
                      og dele fraser med kollegaer og praksispersonale. Det kan
                      du gøre internt i din praksis eller på tværs af
                      praksisser, f.eks. i en praksisklynge eller
                      kædepraksisser. Du kan dele enkelte fraser eller hele
                      mapper med fraser. Aldrig har det været nemmere at
                      samarbejde.
                    </p>
                    <a href="/signup" className="text-doctio-green font-bold">
                      Opret bruger
                    </a>
                  </>
                </CSSTransition>
              </div>

              <div
                className={`hidden ${
                  activeTab === 1 ? "pr-16 md:block" : "hidden"
                }`}
              >
                <CSSTransition
                  key={1}
                  timeout={500}
                  unmountOnExit
                  in={activeTab === 1}
                  classNames={tailwindAnimation}
                >
                  <>
                    <h2 className="text-[2.5rem] mb-6 font-bold text-doctio-green">
                      Opret dine egne fraser, personliggør Doctios fraser og del
                      fraser med dine kollegaer
                    </h2>
                    <p className="mt-2 mb-8 text-left font-medium">
                      Måden at journalføre på er en faglig præference og skøn,
                      og derfor har vi gjort det muligt at tilpasse fraserne til
                      dit behov. Du har hos Doctio mulighed for at oprette dine
                      egne fraser eller redigere eksisterende fraser, så de
                      passer nøjagtig til dig. Desuden har du mulighed for at
                      sende og modtage fraser mellem kollegaer, samt at tilgå
                      Doctios online fraseforum.
                    </p>

                    <a href="/signup" className="text-doctio-green font-bold">
                      Opret bruger
                    </a>
                  </>
                </CSSTransition>
              </div>

              <div
                className={`hidden ${
                  activeTab === 2 ? "pr-16 md:block" : "hidden"
                }`}
              >
                <CSSTransition
                  key={2}
                  timeout={500}
                  unmountOnExit
                  in={activeTab === 2}
                  classNames={tailwindAnimation}
                >
                  <>
                    <h2 className="text-[2.5rem] mb-6 font-bold text-doctio-green">
                      Cloudbaseret teknologi der virker på tværs af
                      journalsystemer
                    </h2>
                    <p className="mt-2 mb-8 text-left font-medium">
                      Doctio gør det muligt at have dine personlige fraser lige
                      ved hånden - uanset om din arbejdsplads skifter fra
                      praksis til lægevagten, du roterer i uddannelsesstillinger
                      eller bare starter et nyt sted. Vores web -og
                      softwareapplikation er desuden uafhængig af forskellige
                      journalsystemer, så hvis du skifter journalsystem mellem
                      Clinea, XMO, Sundhedsplatformen, EPJ etc., eller regionen
                      skifter system, mister du ikke dine fraser. Du har
                      ubegrænset plads til dine fraser.
                    </p>

                    <a href="/signup" className="text-doctio-green font-bold">
                      Opret bruger
                    </a>
                  </>
                </CSSTransition>
              </div>

              <div
                className={`hidden ${
                  activeTab === 3 ? "pr-16 md:block" : "hidden opacity-100"
                }`}
              >
                <CSSTransition
                  key={3}
                  timeout={500}
                  unmountOnExit
                  in={activeTab === 3}
                  classNames={tailwindAnimation}
                >
                  <>
                    <h2 className="text-[2.5rem] mb-6 font-bold text-doctio-green">
                      Dynamiske fraser med indbygger logik og DoctioAssist
                    </h2>
                    <p className="mt-2 mb-8 text-left font-medium">
                      Vi fokuserer på brugervenlighed og ønsker at gøre
                      journalføring let gennem automatiseret makrofunktion med
                      autosuggestion (vi kalder det Smart-Makro). Smart-Makro
                      kan hurtigt og tidsbesparende indsætte fraser eller
                      del-fraser i dit journalsystem vha. et selvvalgt
                      tastaturklik. Hvis du ikke helt kan huske det præcise navn
                      på frasen, som du prøver at indsætte, vil den indbyggende
                      autosuggestion hjælpe dig med at foreslå den frase, du
                      prøver at indsætte.
                    </p>

                    <a href="/signup" className="text-doctio-green font-bold">
                      Opret bruger
                    </a>
                  </>
                </CSSTransition>
              </div>
              <div
                className={`hidden ${
                  activeTab === 4 ? "pr-16 md:block" : "hidden"
                }`}
              >
                <CSSTransition
                  key={4}
                  timeout={500}
                  unmountOnExit
                  in={activeTab === 4}
                  classNames={tailwindAnimation}
                >
                  <>
                    <h2 className="text-[2.5rem] mb-6 font-bold text-doctio-green">
                      GDPR sikkert og øget juridisk sikkerhed
                    </h2>
                    <p className="mt-2 mb-8 text-left font-medium">
                      Vores platform er sikker, og du kan uden problemer bruge
                      Doctio på interne computere i private klinikker, på
                      sygehuset eller uden for landets grænser. Vi behandler
                      ikke patient-personfølsomme data. Doctio kan være være med
                      til at øge din juridiske sikkerhed. I et travlt system kan
                      det ske, at man ikke får journalført allerede givne
                      informationer eller undersøgelser grundet tidspres,
                      hvilket kan resultere i klager. Fraser kan sikre, at man
                      får adspurgt om, undersøgt for og givet relevante
                      informationer og ultimativt får det journalført
                      sufficient. Fraserne skal jf.
                      Journalføringsbekendtgørelsen tilpasses, så teksten passer
                      til den konkrete patientkontakt, og der ikke fremgår
                      irrelevante oplysninger.
                    </p>

                    <a href="/signup" className="text-doctio-green font-bold">
                      Opret bruger
                    </a>
                  </>
                </CSSTransition>
              </div>
            </div>

            <div className="w-5/12">
              <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
